import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/podkit/select/Select";
import { useId, type FC } from "react";

// eslint-disable-next-line react-refresh/only-export-components
export enum WorkflowStatusFilterValue {
    All = "all",
    Running = "running",
    Completed = "completed",
}

const statusFilterOptions = [
    {
        value: WorkflowStatusFilterValue.All,
        label: "All",
    },
    {
        value: WorkflowStatusFilterValue.Running,
        label: "Running",
    },
    {
        value: WorkflowStatusFilterValue.Completed,
        label: "Completed",
    },
];

type WorkflowStatusFilterProps = {
    value: WorkflowStatusFilterValue;
    onChange: (value: WorkflowStatusFilterValue) => void;
};

export const WorkflowStatusFilter: FC<WorkflowStatusFilterProps> = ({ value, onChange }) => {
    const selectId = useId();

    return (
        <Select value={value} onValueChange={onChange}>
            <SelectTrigger id={selectId} loading={false} className="w-44" data-testid="workflow-status-filter-trigger">
                <SelectValue placeholder="Select status" />
            </SelectTrigger>
            <SelectContent>
                {statusFilterOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                        <span>Status: {option.label}</span>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
